define([
  'jquery',
  'URI',
  'color',
  'articles',
  'plugins/text!image-sharer/templates/sharer_popup.html',
  'vex',
  'twitter-text',
  'jquery.naturalwidth',
  'jquery.nearest',
  'jquery.displayrules',
  'plugins/css!../css/sumome-image-sharer.css',
], function($, URI, Color, Articles, modalContentSource, vex, twitterText) {

  $.expr[':'].invisible = $.expr.createPseudo(function(arg) {
    return function(elem) {
      if ($(elem).css("visibility") === "hidden" || $(elem).css("opacity") === 0) {
        console.log('invisible element:', $(elem));
        return true;
      } else {
        var p = $(elem).parent();

        if (p) {
          return p.is(':invisible');
        }

        return false;
      }
    }
  });

  var doSquaresIntersect = function(a, b) {
    return !(b.x > (a.x+a.width)  || (b.x+b.width)  < a.x ||
             b.y > (a.y+a.height) || (b.y+b.height) < a.y);
  };

  var sharer = {
    currentImage: null,
    buttonEl: null,
    win: null,
    currentImageUrl: null,
    currentImageData: null,
    useUrlShortener: true,
    shortener: 'sumoly',
    short_domain: null,
    useAltText: true,
    twitterUsername: null,
    color: null,
    position: null,
    contentOnly: false,
    ignoreLinks: true,
    ignoreImgLinks: false,
    relShareOnly: false,
    ctry: false,
    shortUrls: {},

    scope: function() {
      if (sharer.contentOnly) {
        var articles = Articles.findAll();
        return $(articles);
      }

      return $(document);
    },

    cleanup: function() {
      var scope = sharer.scope();
      console.log(scope);
      scope.off('.image-sharer');
      $(window).off('.image-sharer');
    },

    init: function(data) {
      modalContentSource = modalContentSource.replace('{{preloader}}', sharer.sumoProperties.sumoUrl + '/client/images/apps/55c989d5-855d-4538-b67b-3cdb46acd968/preloader.gif');

      $(window).on('scroll', sharer.debounce(function() {
        sharer.scroll();
      }, 1));

      // Load
      if (data.success) {
        sharer.useAltText = data.use_alt_text;
        sharer.useUrlShortener = data.use_url_shortener;
        sharer.shortener = data.shortener;
        sharer.shortDomain = data.short_domain;
        sharer.contentOnly = data.content_only;
        sharer.ignoreLinks = data.ignore_links;
        sharer.ignoreImgLinks = data.ignore_img_links;
        sharer.relShareOnly = data.rel_share_only;
        sharer.twitterUsername = data.twitter_username;
        sharer.color = data.color;
        sharer.utm = data.utm;
        sharer.utm_source = data.utm_source;
        sharer.utm_medium = data.utm_medium;
        sharer.utm_name = data.utm_name;
        sharer.utm_custom_key = data.utm_custom_key;
        sharer.utm_custom_val = data.utm_custom_val;
        sharer.vertical = data.vertical;
        sharer.vertical_offset = parseInt(data.vertical_offset);
        sharer.vertical_offset_type = data.vertical_offset.replace(/[0-9]/g, '');
        sharer.horizontal_offset = parseInt(data.horizontal_offset);
        sharer.horizontal_offset_type = data.horizontal_offset.replace(/[0-9]/g, '');
        sharer.hasImageSharer = data.hasImageSharer;
        sharer.position = data.position;
        sharer.display_rules = data.display_rules;
        sharer.services = data.services;
        sharer.ctry = (sharer.sumoProperties.geoLocation && sharer.sumoProperties.geoLocation.ctry) ? sharer.sumoProperties.geoLocation.ctry : false;
        sharer.views = (sharer.sumoProperties.views && sharer.sumoProperties.views) ? sharer.sumoProperties.views : false;
        sharer.reflink = 'https://sumome.com/?src=sm-is-' + sharer.sumoProperties.siteId + '&utm_source=sumo-powered-by&utm_medium=image-sharer&utm_campaign='+ sharer.sumoProperties.siteId;
        sharer.setup();
      }

      sharer.api.on('55c989d5-855d-4538-b67b-3cdb46acd968/service/settings', function(data) {
        sharer.hideSharer();
        sharer.cleanup();
        sharer.useAltText = data.use_alt_text;
        sharer.contentOnly = data.content_only;
        sharer.ignoreLinks = data.ignore_links;
        sharer.ignoreImgLinks = data.ignore_img_links;
        sharer.relShareOnly = data.rel_share_only;
        sharer.useUrlShortener = data.use_url_shortener;
        sharer.shortener = data.shortener;
        sharer.shortDomain = data.short_domain;
        sharer.twitterUsername = data.twitter_username;
        sharer.color = data.color;
        sharer.utm = data.utm;
        sharer.utm_source = data.utm_source;
        sharer.utm_medium = data.utm_medium;
        sharer.utm_name = data.utm_name;
        sharer.utm_custom_key = data.utm_custom_key;
        sharer.utm_custom_val = data.utm_custom_val;
        sharer.hasImageSharer = data.hasImageSharer;
        if (sharer.position !== data.position) {
          sharer.position = data.position;
          sharer.positionSharer();
        }
        sharer.display_rules = data.display_rules;
        sharer.services = data.services;
        sharer.setup();
      });
    },

    setup: function() {
      sharer.buttonEl = $('<div class="sumome-image-sharer"></div>');

      var services = sharer.services.slice(0);

      // Appends the service buttons
      services.forEach($.proxy(function(service) {
        console.log(service);
        var serviceClasses = 'sumome-image-sharer-' + service

        if (service === 'yummly') {
          serviceClasses += ' sumome-image-sharer-src-only';
        }

        var aEl = $('<a href="javascript:void(0);" class="' + serviceClasses + '"><div></div></a>');

        if (sharer.vertical) {
          aEl.addClass('sumome-image-sharer-vertical');
        }

        if (sharer.color) {
          var defaultCss = {
            backgroundColor: sharer.color,
            borderColor: Color.shadeColor(sharer.color, -5),
          };

          aEl.css(defaultCss)
            .hover(
              $.proxy(function() {
                $(this).css({
                  backgroundColor: Color.shadeColor(sharer.color, 5),
                  borderColor: sharer.color,
                });
              }),
              $.proxy(function() {
                $(this).css(defaultCss);
              })
            );

          var defaultImageCss = {};

          // Potentially swaps icon
          if (Color.whiteOrBlack(sharer.color) === 'black') {
            defaultImageCss.backgroundImage = 'url("' + this.sumoProperties.baseUrl + 'images/apps/55c989d5-855d-4538-b67b-3cdb46acd968/' + service + '-black-60.png")';
          }

          aEl.find('div').css(defaultImageCss)
            .hover(
              $.proxy(function() {
                $(this).css(defaultImageCss);
              })
            );
        }

        sharer.buttonEl.append(aEl);
      }, sharer));

      if (sharer.vertical) {
        sharer.buttonEl.css('width', 40);
        sharer.buttonEl.css('height', 40 * sharer.services.length);
      } else {
        sharer.buttonEl.css('width', 40 * sharer.services.length);
      }

      sharer.buttonEl.on('click', 'a.sumome-image-sharer-twitter', sharer.openTwitter);
      sharer.buttonEl.on('click', 'a.sumome-image-sharer-facebook', sharer.openFacebook);
      sharer.buttonEl.on('click', 'a.sumome-image-sharer-pinterest', sharer.openPinterest);
      sharer.buttonEl.on('click', 'a.sumome-image-sharer-yummly', sharer.openYummly);

      $('body').append(sharer.buttonEl);

      if ($.isCurrentUrlAllowed(sharer.display_rules, null, sharer.ctry, sharer.views)) {
        var scope = sharer.scope();
        console.log(scope);
        scope.on('mouseenter.image-sharer', 'img', sharer.debounce(sharer.mouseenter, 250));
        scope.on('mouseleave.image-sharer', 'img', sharer.debounce(sharer.mouseleave, 250));
        $(window).on('touchstart.image-sharer', sharer.debounce(sharer.touch, 200));
        $(window).on('resize.image-sharer', sharer.throttle(sharer.positionSharer, 150));
      }
    },

    debounce: function(func, wait) {
      var timeout;
      return function() {
        var context = this, args = arguments;
        clearTimeout(timeout);
        timeout = setTimeout(function() {
          timeout = null;
          func.apply(context, args);
        }, wait);
        if (!timeout) func.apply(context, args);
      };
    },

    throttle: function(func, wait) {
      var context, args, result;
      var timeout = null;
      var previous = 0;
      var later = function() {
        previous = new Date().getTime();
        timeout = null;
        result = func.apply(context, args);
        if (!timeout) context = args = null;
      };
      return function() {
        var now = new Date().getTime();
        if (!previous) previous = now;
        var remaining = wait - (now - previous);
        context = this;
        args = arguments;
        if (remaining <= 0 || remaining > wait) {
          clearTimeout(timeout);
          timeout = null;
          previous = now;
          result = func.apply(context, args);
          if (!timeout) context = args = null;
        } else if (!timeout) {
          timeout = setTimeout(later, remaining);
        }
        return result;
      };
    },

    loadImageProperties: function imageSharerLoadImageProperties(service) {
      var imageSrc = sharer.currentImage.attr('src');

      if (sharer.useAltText) {
        sharer.currentImageAlt = sharer.currentImage.attr('alt') || $(document).find("title").text() || '';
      } else {
        sharer.currentImageAlt = $(document).find("title").text() || '';
      }

      try {
        if (imageSrc.indexOf('data:image') === 0) {
          sharer.currentImageUrl = imageSrc;
          sharer.currentImageData = imageSrc;

          // Forced exception to trigger checking srcset
          if (service === 'yummly') throw new Error();
        } else {
          sharer.currentImageUrl = new URI(imageSrc).absoluteTo(window.location.toString()).toString();
          sharer.currentImageData = sharer.getImageData(sharer.currentImage);
        }

        return true;
      } catch (err) {
        // No image data, src is bad, maybe we can use the srcset
        var imageSrcSet = sharer.currentImage.attr('srcset');
        var sortedSrcSet = [];

        if (!imageSrcSet) return false;

        imageSrcSet = imageSrcSet.split(',');

        if (imageSrcSet && imageSrcSet.length) {
          imageSrcSet.forEach(function (image) {
            image = image.trim().split(' ');

            if (image && image.length === 2) {
              sortedSrcSet.push({ src: image[0], weight: parseInt(image[1]) });
            }
          });

          // Sorts so we can grab the best resolution when sharing
          sortedSrcSet.sort(function (a, b) { return b.weight - a.weight; });
        }

        if (!sortedSrcSet.length) return false;

        try {
          sharer.currentImageUrl = new URI(sortedSrcSet[0].src).absoluteTo(window.location.toString()).toString();
          sharer.currentImageData = sharer.getImageData(sharer.currentImage);

          return true;
        } catch (err) {
          console.log(err);
          return false;
        }
      }
    },

    // facebook
    openFacebook: function(e) {
      e.preventDefault();
      sharer.api.emit('event', { 'appId': '55c989d5-855d-4538-b67b-3cdb46acd968', 'event': 'facebook-click' });

      if (!sharer.loadImageProperties('facebook')) {
        console.log('Unable to share image');
        return;
      }

      var url = window.location.toString();
      url = sharer.checkAndAddUTMParams(url, 'facebook');

      sharer.win = window.open('https://www.facebook.com/sharer/sharer.php?u=' + encodeURIComponent(sharer.currentImageUrl) + '&quote=' + encodeURIComponent(sharer.currentImageAlt) + '&display=popup', 'Sumo Facebook Share', 'width=400,height=400');
    },

    generateShare: function(share) {
      var url = window.location.href;
      url = sharer.checkAndAddUTMParams(url, 'facebook');

      if (sharer.useUrlShortener) {
        var urlKey = sharer.shortener + ':' + url;

        if (urlKey in sharer.shortUrls) {
          sharer.generateShareFromUrl(share, sharer.shortUrls[urlKey]);
        } else {
          $.ajax({
            type: 'POST',
            dataType: 'json',
            url: sharer.sumoProperties.sumoUrl + '/apps/image-sharer/shorten',
            data: {
              site_id: sharer.sumoProperties.siteId,
              href: url
            },
            xhrFields: {
              withCredentials: false
            },
            crossDomain: true
          }).done(function(response) {
            if (response.success) {
              sharer.shortUrls[urlKey] = response.url;
              url = response.url;
            }

            sharer.generateShareFromUrl(share, url);
          });
        }
      } else {
        sharer.generateShareFromUrl(share, url);
      }
    },

    generateShareFromUrl: function(share, url) {
      share = (share + ' ' + url).trim();

      sharer.$modal.find('textarea').val(share);
      sharer.$modal.find('.sumome-image-sharer-link').attr('href', sharer.reflink);
      sharer.$modal.find('.sumome-image-sharer-fb-message').text(share);
    },

    // load FB dialog markup - will be either connect or share
    loadFacebookMarkup: function(once) {
      $.ajax({
        type: 'POST',
        xhrFields: {
          withCredentials: true
        },
        crossDomain: true,
        url: sharer.sumoProperties.sumoUrl + '/apps/image-sharer/facebook/load',
        data: {
          site_id: sharer.sumoProperties.siteId,
        },
        statusCode: {
          401: function() {
            if (!once) {
              sharer.loadFacebookMarkup();
            }
          }
        },
        success: function(data) {
          data = data.replace('{{sumome-icon}}', sharer.sumoProperties.sumoUrl + '/client/images/apps/55c989d5-855d-4538-b67b-3cdb46acd968/sumome-crown-128.png');
          data = data.replace('{{facebook-icon}}', sharer.sumoProperties.sumoUrl + '/client/images/apps/55c989d5-855d-4538-b67b-3cdb46acd968/facebook-icon-128.png');
          $('#sumome-image-sharer').html(data);

          var $connect = $('#sumome-image-sharer .sumome-connect');

          if ($connect.length > 0) {
            // not authenticated - connect click button

            sharer.goSmall();
            sharer.$modal.find('.sumome-image-sharer-link').attr('href', sharer.reflink);

            $connect.click(sharer.authenticateFacebook);
          } else {
            sharer.goLarge();

            // authenticated - fill in and connect widgets
            sharer.$modal.find('.sumome-image-sharer-fb-image').css('background-image', 'url(' + sharer.currentImageUrl + ')');
            sharer.generateShare(sharer.currentImageAlt);

            sharer.$modal.find('select').change(function() {
              var $option = $(this).find('option').filter(':selected');
              var name = $option.text();
              var id = $option.attr('value');
              var accessToken = $option.data('access-token');

              sharer.$modal.find('.sumome-image-sharer-fb-user img').attr('src', 'https://graph.facebook.com/v2.8/' + id + '/picture?access_token=' + accessToken);
              sharer.$modal.find('.sumome-image-sharer-fb-user a').text(name);
            });

            sharer.$modal.find('textarea').on('keyup', function() {
              sharer.$modal.find('.sumome-image-sharer-fb-message').text($(this).val());
            });

            sharer.$modal.find('button').click(sharer.submitFacebook);
            sharer.$modal.find('.sumome-image-sharer-fb-message').focus();

            sharer.$modal.resize();
          }
        }
      });
    },

    // poll FB oauth dialog for closure
    checkFacebookWindowClosed: function() {
      if (sharer.isAuthWindowClosed()) {
        sharer.loadFacebookMarkup();
      } else {
        setTimeout(sharer.checkFacebookWindowClosed, 500);
      }
    },

    // show FB oauth dialog
    authenticateFacebook: function() {
      if (sharer.isAuthWindowClosed()) {
        sharer.win = window.open(sharer.sumoProperties.sumoUrl + '/apps/image-sharer/facebook/login', 'image-sharer-auth', 'width=640,height=400');
        sharer.win.focus();
        sharer.checkFacebookWindowClosed();
      } else {
        sharer.win.location = sharer.sumoProperties.sumoUrl + '/apps/image-sharer/facebook/login';
        sharer.win.resizeTo(640, 400);
        sharer.win.focus();
        sharer.checkFacebookWindowClosed();
      }
    },

    // submit image+text to FB
    submitFacebook: function() {
      var status = sharer.$modal.find('textarea').val().trim();
      var image_url = sharer.currentImageUrl;

      var $option = sharer.$modal.find('option').filter(':selected');
      var name = $option.text();
      var targetId = $option.attr('value');
      var targetToken = $option.data('access-token');

      sharer.$modal.find('select, textarea, button').prop('disabled', true);

      $.ajax({
        type: 'POST',
        dataType: 'json',
        beforeSend: function(req) {
          req.setRequestHeader('X-Sumo-Auth', $.cookie('__smToken'));
        },
        xhrFields: {
          withCredentials: true
        },
        crossDomain: true,
        url: sharer.sumoProperties.sumoUrl + '/apps/image-sharer/facebook/post',
        data: {
          status: status,
          image_url: image_url,
          image_data: sharer.currentImageData,
          targetId: targetId,
          targetToken: targetToken
        },
        statusCode: {
          401: function() {
            sharer.loadFacebookMarkup();
          },
          500: function() {
            sharer.close();
          }
        },
        success: function(data) {
          if (data.success) {
            sharer.api.emit('event', { 'appId': '55c989d5-855d-4538-b67b-3cdb46acd968', 'event': 'facebook-share' });
            sharer.goSmall();
            $('#sumome-image-sharer').html('<div class="sumome-12 sumome-columns sumome-text-center"><h3>Snap!</h3><h5>Your photo was shared.</h5><hr><button class="sumome-button sumome-radius sumome-expand">Okay</button></div>');
            $('#sumome-image-sharer').find('button').click(function(e) {sharer.close();});
            sharer.$modal.resize();
            $.timer('closeImageSharer', sharer.close, 3000).start();
          } else {
            sharer.goSmall();

            sharer.showError(data.error);
            $('#sumome-image-sharer').find('button').click(function(e) {sharer.close();});
            sharer.$modal.resize();
          }
        }
      });
    },

    // twitter
    openTwitter: function(e) {
      e.preventDefault();
      sharer.api.emit('event', { 'appId': '55c989d5-855d-4538-b67b-3cdb46acd968', 'event': 'twitter-click' });

      if (!sharer.loadImageProperties('twitter')) {
        console.log('Unable to share image');
        return;
      }

      sharer.$modal = vex.open({
        content: modalContentSource,
        overlayClosesOnClick: false,
        className: 'sumome-image-sharer-popup sumome-image-sharer-popup-small',
        overlayClassName: 'sumome-image-sharer-popup-overlay',
        contentClassName: 'sumome-image-sharer-popup-content',
        closeClassName: 'sumome-image-sharer-popup-close'
      });

      sharer.$modal.on('vexClose', function() {
        var t = $.timer('closeImageSharer');

        if (t) {
          t.stop();
        }
      });

      sharer.$modal.on('vexResize', $.proxy(function(e, options) {
        var paddings = Math.max(($(window).height() - options.$vexContent.outerHeight()) / 2, 0);
        options.$vex.css({
          'padding-top': paddings + 'px'
        });
      }, this));

      sharer.$modal.on('vexOpen', $.proxy(function(e, options) {
        sharer.$modal.resize();
        sharer.loadTwitterMarkup();
      }, this));
    },

    generateTweet: function(tweet) {
      var url = window.location.href;
      url = sharer.checkAndAddUTMParams(url, 'twitter');

      if (sharer.useUrlShortener) {
        var urlKey = sharer.shortener + ':' + url;

        if (urlKey in sharer.shortUrls) {
          sharer.generateTweetFromUrl(tweet, sharer.shortUrls[urlKey]);
        } else {
          $.ajax({
            type: 'POST',
            dataType: 'json',
            url: sharer.sumoProperties.sumoUrl + '/apps/image-sharer/shorten',
            data: {
              site_id: sharer.sumoProperties.siteId,
              href: url
            },
            xhrFields: {
              withCredentials: false
            },
            crossDomain: true
          }).done(function(response) {
            if (response.success) {
              sharer.shortUrls[urlKey] = response.url;
              url = response.url;
            }

            sharer.generateTweetFromUrl(tweet, url);
          });
        }
      } else {
        sharer.generateTweetFromUrl(tweet, url);
      }
    },

    generateTweetFromUrl: function(tweet, url) {
      // Both 23 according to https://api.twitter.com/1.1/help/configuration.json
      var urlLength = (url.substr(0, 6) === 'https:') ? 23 : 23;
      var viaTwitterHandle = sharer.twitterUsername;
      var tweetLength = 280 - 24 - urlLength; // 24 reserved per media

      if (viaTwitterHandle) {
        if (viaTwitterHandle.substr(0,1) !== '@') {
          viaTwitterHandle = '@' + viaTwitterHandle;
        }

        tweetLength -= 5 + viaTwitterHandle.length;
      }

      tweet = tweet.trim();
      tweet = tweet.replace(/\r\n|\n|\r/g, ' ');

      if ((tweet.length + 1) > tweetLength) {
        tweet = tweet.substr(0, tweetLength - 2) + '…';
      }

      tweet = (tweet + ' ' + url + (viaTwitterHandle ? (' via ' + viaTwitterHandle) : '')).trim();

      sharer.$modal.find('textarea').val(tweet);
      sharer.$modal.find('.sumome-image-sharer-link').attr('href', sharer.reflink);
      sharer.$modal.find('.sumome-image-sharer-tw-message').text(tweet);
      sharer.updateTwitterCount();
    },

    updateTwitterCount: function() {
      var status = sharer.$modal.find('textarea').val().trim();
      var count = sharer.charactersLeft(status);

      sharer.$modal.find('.sumome-image-sharer-tw-count').html(count + ' chars remaining');

      if (count < 0) {
        sharer.$modal.find('.sumome-image-sharer-tw-count').css({'color': 'red'});
      } else {
        sharer.$modal.find('.sumome-image-sharer-tw-count').css({'color': ''});
      }
    },

    // load Twitter dialog markup - will be either connect or share
    loadTwitterMarkup: function(once) {
      $.ajax({
        type: 'POST',
        xhrFields: {
          withCredentials: true
        },
        crossDomain: true,
        url: sharer.sumoProperties.sumoUrl + '/apps/image-sharer/twitter/load',
        data: {
          site_id: sharer.sumoProperties.siteId,
        },
        statusCode: {
          401: function() {
            if (!once) {
              sharer.loadTwitterMarkup();
            }
          }
        },
        success: function(data) {
          data = data.replace('{{sumome-icon}}', sharer.sumoProperties.sumoUrl + '/client/images/apps/55c989d5-855d-4538-b67b-3cdb46acd968/sumome-crown-128.png');
          data = data.replace('{{twitter-icon}}', sharer.sumoProperties.sumoUrl + '/client/images/apps/55c989d5-855d-4538-b67b-3cdb46acd968/twitter-icon-128.png');
          $('#sumome-image-sharer').html(data);

          var $connect = $('#sumome-image-sharer .sumome-connect');

          if ($connect.length > 0) {
            sharer.goSmall();
            sharer.$modal.find('.sumome-image-sharer-link').attr('href', sharer.reflink);

            // not authenticated - connect click button
            $connect.click(sharer.authenticateTwitter);
          } else {
            sharer.goLarge();

            // authenticated - fill in and connect widgets
            sharer.$modal.find('.sumome-image-sharer-tw-image').css('background-image', 'url(' + sharer.currentImageUrl + ')');
            sharer.generateTweet(sharer.currentImageAlt);

            sharer.$modal.find('textarea').on('keyup', function() {
              sharer.$modal.find('.sumome-image-sharer-tw-message').text($(this).val());
              sharer.updateTwitterCount();
            });

            sharer.$modal.find('button').click(sharer.submitTwitter);
            sharer.$modal.find('.sumome-image-sharer-tw-message').focus();

            sharer.$modal.resize();
          }
        }
      });
    },

    checkTwitterWindowClosed: function() {
      if (sharer.isAuthWindowClosed()) {
        sharer.loadTwitterMarkup();
      } else {
        setTimeout(sharer.checkTwitterWindowClosed, 500);
      }
    },

    authenticateTwitter: function() {
      if (sharer.isAuthWindowClosed()) {
        sharer.win = window.open(sharer.sumoProperties.sumoUrl + '/apps/image-sharer/twitter/login', 'image-sharer-auth', 'width=740,height=400');
        sharer.win.focus();
        sharer.checkTwitterWindowClosed();
      } else {
        sharer.win.location = sharer.sumoProperties.sumoUrl + '/apps/image-sharer/twitter/login';
        sharer.win.resizeTo(740, 400);
        sharer.win.focus();
        sharer.checkTwitterWindowClosed();
      }
    },

    submitTwitter: function() {
      var status = sharer.$modal.find('textarea').val().trim();
      var image_url = sharer.currentImageUrl;

      sharer.$modal.find('textarea, button').prop('disabled', true);
      var status = sharer.$modal.find('textarea').val().trim();
      var count = sharer.charactersLeft(status);

      if (count >= 0) {
        $.ajax({
          type: 'POST',
          dataType: 'json',
          beforeSend: function(req) {
            req.setRequestHeader('X-Sumo-Auth', $.cookie('__smToken'));
          },
          xhrFields: {
            withCredentials: true
          },
          crossDomain: true,
          url: sharer.sumoProperties.sumoUrl + '/apps/image-sharer/twitter/post',
          data: {
            status: status,
            image_url: image_url,
            image_data: sharer.currentImageData
          },
          statusCode: {
            401: function() {
              sharer.loadTwitterMarkup();
            }
          },
          success: function(data) {
            if (data.success) {
              sharer.api.emit('event', { 'appId': '55c989d5-855d-4538-b67b-3cdb46acd968', 'event': 'twitter-share' });
              sharer.goSmall();
              $('#sumome-image-sharer').html('<div class="sumome-12 sumome-columns sumome-text-center"><h3>Snap!</h3><h5>Your photo was shared.</h5><hr><button class="sumome-button sumome-radius sumome-expand">Okay</button></div>');
              $('#sumome-image-sharer').find('button').click(function(e) {sharer.close();});
              sharer.$modal.resize();
              $.timer('closeImageSharer', sharer.close, 3000).start();
            } else {
              sharer.goSmall();

              sharer.showError(data.error);
              $('#sumome-image-sharer').find('button').click(function(e) {sharer.close();});
              sharer.$modal.resize();
            }
          }
        });
      } else {
        sharer.$modal.find('textarea, button').prop('disabled', false);
      }
    },

    // pinterest
    openPinterest: function(e) {
      e.preventDefault();

      sharer.api.emit('event', { 'appId': '55c989d5-855d-4538-b67b-3cdb46acd968', 'event': 'pinterest-click' });

      if (!sharer.loadImageProperties('pinterest')) {
        console.log('Unable to share image');
        return;
      }

      var url = window.location.toString();
      url = sharer.checkAndAddUTMParams(url, 'pinterest');

      sharer.closeAuthWindow();
      sharer.win = window.open(sharer.generatePinterestUrl(url), 'image-sharer-pinterest', 'width=640,height=320');
    },

    generatePinterestUrl: function(url) {
      var param = {
        url: url,
        media: sharer.currentImageUrl,
        description: sharer.currentImageAlt
      };

      return 'http://pinterest.com/pin/create/button/?' + $.param(param);
    },

    // yummly
    openYummly: function(e) {
      e.preventDefault();

      sharer.api.emit('event', { 'appId': '55c989d5-855d-4538-b67b-3cdb46acd968', 'event': 'yummly-click' });

      if (!sharer.loadImageProperties('yummly')) {
        console.log('Unable to share image');
        return;
      }

      var url = window.location.toString();
      url = sharer.checkAndAddUTMParams(url, 'yummly');

      sharer.closeAuthWindow();
      sharer.win = window.open(sharer.generateYummlyUrl(url), 'image-sharer-yummly', 'width=600,height=500');
    },

    generateYummlyUrl: function(url) {
      var param = {
        url: url,
        title: sharer.currentImageAlt,
        image: sharer.currentImageUrl
      };

      return 'http://www.yummly.com/urb/verify?' + $.param(param);
    },

    // shared
    goSmall: function() {
      sharer.$modal.closest('.sumome-image-sharer-popup').removeClass('sumome-image-sharer-popup-large').addClass('sumome-image-sharer-popup-small');
      this.resize();
    },

    goLarge: function() {
      sharer.$modal.closest('.sumome-image-sharer-popup').removeClass('sumome-image-sharer-popup-small').addClass('sumome-image-sharer-popup-large');
      this.resize();
    },

    resize: function() {
      var modalEl = sharer.$modal.closest('.sumome-image-sharer-popup');

      var size = 'small';
      var width = modalEl.innerWidth();

      if (width >= 1440) {
        size = 'xxlarge';
      } else if (width >= 1080) {
        size = 'xlarge';
      } else if (width >= 768) {
        size = 'large';
      } else if (width >= 480) {
        size = 'medium';
      } else {
        size = 'small';
      }

      var className = "sumome-res-" + size;
      modalEl.removeClass("sumome-res-small sumome-res-medium sumome-res-large sumome-res-xlarge sumome-res-xxlarge").addClass(className);
    },

    showError: function(error) {
      $('#sumome-image-sharer').html('<div class="sumome-12 sumome-columns sumome-text-center"><h3>Golly Gee Wilikers</h3><h5>' + error + '</h5><hr><button class="sumome-button sumome-alert sumome-radius sumome-expand">Close</button></div>');
    },

    close: function() {
      sharer.closeAuthWindow();
      vex.close();
    },

    openAuthWindow: function() {
      if (sharer.isAuthWindowClosed()) {
        sharer.win = window.open('about:blank', 'image-sharer-auth', 'width=1,height=1');
      }
    },

    isAuthWindowClosed: function() {
      return (!sharer.win || sharer.win.closed);
    },

    closeAuthWindow: function() {
      if (!sharer.isAuthWindowClosed()) {
        sharer.win.close();
        sharer.win = null;
      }
    },

    mouseenter: function(e) {
      var width = Math.min(window.screen.availWidth || $(window).width(),  $(window).width());
      if ($.isCurrentUrlAllowed(sharer.display_rules, null, sharer.ctry, sharer.views)) {
        var t = $.timer('hideImageSharer');

        if (t) {
          t.kill();
        }

        sharer.currentImage = null;
        var target = $(e.target);

        var naturalWidth = target.naturalWidth();
        var naturalHeight = target.naturalHeight();
        var width = target.width();
        var height = target.height();

        if (naturalWidth < 150 || naturalHeight < 150) {
          console.log('target is too small');
          sharer.buttonEl.stop(true, true).fadeOut(500);
          return;
        }

        // Force include if:
        // * Image has rel="share" attribute

        // Do not include if:
        // * Image is wrapped in an anchor tag with an href that is not a link to itself or a .jpg/.gif/.png
        // * Image is nested inside a form
        // * Image has rel="noshare" attribute
        // * Image is part of a content network like Outbrain
        // * Image is part of an ad network like Mode Media

        if (target.parent().is('div[id^=grs_]')) {
          console.log('target is part of an ad network');
          sharer.buttonEl.stop(true, true).fadeOut(500);
          return;
        }

        if (target.is('.ob-widget *')) {
          console.log('target is part of a content network');
          sharer.buttonEl.stop(true, true).fadeOut(500);
          return;
        }

        if (target.is('.s.u.m.o.me *')) {
          console.log('target is part of a sumo tool');
          sharer.buttonEl.stop(true, true).fadeOut(500);
          return;
        }

        if (target.attr('rel') && target.attr('rel').toLowerCase().indexOf('noshare') === 0) {
          console.log('target has no share');
          sharer.buttonEl.stop(true, true).fadeOut(500);
          return;
        }

        if (target.attr('rel') && target.attr('rel').toLowerCase().indexOf('share') === 0) {
          console.log('target is force-shared');
        } else {
          var parent = target.parent();
          var r = /[^/\\]+(?:jpg|gif|png)/gi;

          if (sharer.ignoreLinks) {
            if (parent && parent.get(0).tagName.toUpperCase() === 'A' && parent.attr('href') && parent.attr('href') !== target.attr('src') && parent.attr('href').match(r) === null) {
              console.log('target links somewhere else');
              sharer.buttonEl.stop(true, true).fadeOut(500);
              return;
            }
          }

          if (sharer.ignoreImgLinks) {
            if (parent && parent.get(0).tagName.toUpperCase() === 'A' && parent.attr('href') && parent.attr('href') !== target.attr('src') && parent.attr('href').match(r) !== null) {
              console.log('target images somewhere else');
              sharer.buttonEl.stop(true, true).fadeOut(500);
              return;
            }
          }

          if (target.parents('form').length > 0) {
            console.log('target is inside a form');
            sharer.buttonEl.stop(true, true).fadeOut(500);
            return;
          }

          if (target.is(':hidden') || target.is(':invisible')) {
            console.log('target is invisible');
            sharer.buttonEl.stop(true, true).fadeOut(500);
            return;
          }

          if (sharer.relShareOnly) {
            console.log('target does not have rel="share"');
            sharer.buttonEl.stop(true, true).fadeOut(500);
            return;
          }
        }

        console.info('enter: ' + e.target.nodeName);
        console.info('width: ' + $(e.target).naturalWidth());

        sharer.currentImage = $(e.target);

        sharer.positionSharer();

        if (!sharer.isOverFixedHeader()) {
          sharer.buttonEl.stop(true, true).fadeIn(500);
        }
      }
    },

    visibleArea: function(node) {
      var o = {height: node.offsetHeight, width: node.offsetWidth, isRelative: false }, // size
          d = {y: (node.offsetTop || 0), x: (node.offsetLeft || 0), node: node.offsetParent}, // position
          css, y, x, top, left;

      while(!$(node).is('body') && null !== (node = node.parentNode)) { // loop up through DOM
        try{
          css = window.getComputedStyle(node);
        } catch(err) {
          console.log(node);
          console.log(err);
        }

        if (css && css.position === 'relative') {
          o.isRelative = true;
        }

        if (css && css.overflow === 'hidden') { // if has style && overflow
          y = node.offsetHeight - Math.max($('body').offset().top, d.y); // calculate visible y
          x = node.offsetWidth - Math.max($('body').offset().left, d.x); // and x

          if (node !== d.node) {
            y = y + (node.offsetTop || 0); // using || 0 in case it doesn't have an offsetParent
            x = x + (node.offsetLeft || 0);
          }

          if (y < o.height) {
            if (y < 0) o.height = 0;
            else o.height = y;
          }

          if (x < o.width) {
            if (x < 0) o.width = 0;
            else o.width = x;
          }

          return o; // return (modify if you want to loop up again)
        }

        if (node === d.node) { // update offsets
          d.y = d.y + (node.offsetTop || 0);
          d.x = d.x + (node.offsetLeft || 0);
          d.node = node.offsetParent;
        }
      }
      return o;
    },

    positionSharer: function() {
      // Don't reposition if we've just clicked share
      if (sharer.currentImage === null || $('.sumome-image-sharer-popup-content').is(':visible')) {
        return;
      }

      var pos = sharer.currentImage.offset();
      var parentPos = sharer.currentImage.offsetParent().offset();
      var visible = sharer.visibleArea(sharer.currentImage[0]);
      var hasHiddenOverflow = visible.hasHiddenOverflow;
      var positioned = (['absolute'].indexOf(sharer.currentImage.css('position')) >= 0);

      if (positioned) {
        if (visible.isRelative) {
          var positionTypes = ['absolute','fixed','relative'];
        } else {
          var positionTypes = ['absolute','fixed'];
        }

        var positionedParents = sharer.currentImage.parents().filter(function() {
          return !$(this).is('body,html') && positionTypes.indexOf($(this).css('position')) >= 0;
        });

        positioned = positionedParents && positionedParents.length;
      }

      var effectivePaddingTop = null;
      var effectivePaddingLeft = null;
      var topFix = null;
      var leftFix = null;

      if (positioned) {
        var top = Math.max($('body').offset().top + (isNaN(parseFloat($('body').css('padding-top'))) ? 0 : parseFloat($('body').css('padding-top'))), pos.top - (pos.top - parentPos.top));
        var left = Math.max($('body').offset().left + (isNaN(parseFloat($('body').css('padding-left'))) ? 0 : parseFloat($('body').css('padding-left'))), pos.left - (pos.left - parentPos.left));
        var effectivePaddingTop = parseFloat(isNaN(parseFloat(sharer.currentImage.css('padding-top'))) ? 0 : parseFloat(sharer.currentImage.css('padding-top'))) + parseFloat(isNaN(parseFloat(sharer.currentImage.css('border-top'))) ? 0 : sharer.currentImage.css('border-top'));
        var effectivePaddingLeft = parseFloat(isNaN(parseFloat(sharer.currentImage.css('padding-left'))) ? 0 : parseFloat(sharer.currentImage.css('padding-left'))) + parseFloat(isNaN(parseFloat(sharer.currentImage.css('border-left'))) ? 0 : sharer.currentImage.css('border-left'));

        if ((pos.top - top) + effectivePaddingTop < 0) {
          topFix = 0;
        } else {
          topFix = (pos.top - top) + effectivePaddingTop;
        }

        if ((pos.left - left) + effectivePaddingLeft < 0) {
          leftFix = 0;
        } else {
          leftFix = (pos.left - left) + effectivePaddingLeft;
        }
      } else if (sharer.currentImage.css('position') === 'fixed') {
        var top = sharer.currentImage.position().top;
        var left = sharer.currentImage.position().left;
      } else {
        var top = Math.max($('body').offset().top + (isNaN(parseFloat($('body').css('padding-top'))) ? 0 : parseFloat($('body').css('padding-top'))), pos.top);
        var left = Math.max($('body').offset().left + (isNaN(parseFloat($('body').css('padding-left'))) ? 0 : parseFloat($('body').css('padding-left'))), pos.left);
      }

      if (effectivePaddingTop === null) {
        var effectivePaddingTop = parseFloat(isNaN(sharer.currentImage.css('padding-top')) ? 0 : sharer.currentImage.css('padding-top')) + isNaN(parseFloat(sharer.currentImage.css('border-top'))) ? 0 : parseFloat(sharer.currentImage.css('border-top'));
        var effectivePaddingLeft = parseFloat(isNaN(sharer.currentImage.css('padding-left')) ? 0 : sharer.currentImage.css('padding-left')) + isNaN(parseFloat(sharer.currentImage.css('border-left'))) ? 0 : parseFloat(sharer.currentImage.css('border-left'));
      }

      var effectivePaddingBottom = parseFloat(isNaN(sharer.currentImage.css('padding-left')) ? 0 : sharer.currentImage.css('padding-bottom')) + isNaN(parseFloat(sharer.currentImage.css('border-bottom'))) ? 0 :  parseFloat(sharer.currentImage.css('border-bottom'));
      var effectivePaddingRight = parseFloat(isNaN(sharer.currentImage.css('padding-left')) ? 0 : sharer.currentImage.css('padding-right')) + isNaN(parseFloat(sharer.currentImage.css('border-right'))) ? 0 : parseFloat(sharer.currentImage.css('border-right'));
      var height = visible.height - ((topFix !== null) ? (top - pos.top) + topFix : effectivePaddingTop) - effectivePaddingBottom;
      var width = visible.width - ((leftFix !== null) ? (left - pos.left) + leftFix : effectivePaddingLeft) - effectivePaddingRight;

      var topPositioner = ((topFix !== null) ? topFix : effectivePaddingTop);
      var leftPositioner = ((leftFix !== null) ? leftFix : effectivePaddingLeft);
      var sharePosition = {};
      var vOffset = sharer.vertical_offset_type === 'px' ? sharer.vertical_offset : height * (sharer.vertical_offset / 100);
      var hOffset = sharer.horizontal_offset_type === 'px' ? sharer.horizontal_offset : width * (sharer.horizontal_offset / 100);

      // Figures out if we're working with an inlined image
      var imageSrc = sharer.currentImage.attr('src');
      var showSrcOnlyServices = true;

      try {
        if (imageSrc.indexOf('data:image') === 0) {
          showSrcOnlyServices = false;
        } else {
          sharer.currentImageUrl = new URI(imageSrc).absoluteTo(window.location.toString()).toString();
          sharer.currentImageData = sharer.getImageData(sharer.currentImage);
        }
      } catch (e) {
        showSrcOnlyServices = false;
      }

      if (!showSrcOnlyServices) {
        console.log('target is using image data.');

        // Checks to see if we have srcset
        var imageSrcSet = sharer.currentImage.attr('srcset');

        if (imageSrcSet) {
          imageSrcSet = imageSrcSet.split(',');

          // Checks if we have a valid srcset image, show all services if we do
          if (imageSrcSet && imageSrcSet.length) {
            imageSrcSet.forEach(function (image) {
              if (showSrcOnlyServices) return;
              image = image.trim().split(' ');
              if (image && image.length === 2) showSrcOnlyServices = true;
            });
          }
        }
      }

      // Hides the services that don't support inlined images
      var $srcOnlyServiceEls = sharer.buttonEl.find('.sumome-image-sharer-src-only');
      $srcOnlyServiceEls.toggle(showSrcOnlyServices);

      // Styles to be applied
      var borderWidth = '2px 0';
      var firstWidth = '2px 0 2px 2px';
      var lastWidth = '2px 2px 2px 0';
      var firstRadius = '3px 0 0 3px';
      var lastRadius = '0 3px 3px 0';

      if (sharer.vertical) {
        borderWidth = '0 2px';
        firstWidth = '2px 2px 0 2px';
        lastWidth = '0 2px 2px 2px';
        firstRadius = '3px 3px 0 0';
        lastRadius = '0 0 3px 3px';
      }

      // Resets the styles
      sharer.buttonEl.find('> a').css({
        borderRadius: '0px',
        borderWidth: borderWidth,
      });

      // Finds our visible buttons
      var $buttonEls = sharer.buttonEl.find('> a' + (
        showSrcOnlyServices ? '' : ':not(.sumome-image-sharer-src-only)'
      ));

      // Restyles the first and last buttons
      $buttonEls.first().css({ borderRadius: firstRadius, borderWidth: firstWidth });
      $buttonEls.last().css({ borderRadius: lastRadius, borderWidth: lastWidth });

      // Figures out how many services are active
      var servicesLength = sharer.services.length;

      if (!showSrcOnlyServices && $srcOnlyServiceEls && $srcOnlyServiceEls.length) {
        servicesLength -= $srcOnlyServiceEls.length;
      }

      var sharerHeight = (sharer.vertical ? 40 * servicesLength : 40);
      var sharerWidth = (sharer.vertical ? 40 : 40 * servicesLength);

      // Resize the container too
      if (sharer.vertical) {
        sharer.buttonEl.css('width', 40);
        sharer.buttonEl.css('height', 40 * servicesLength);
      } else {
        sharer.buttonEl.css('width', 40 * servicesLength);
      }

      // Add addition padding to vertical and horizontal offsets when not centered
      if (sharer.position !== 'c') {
        vOffset += 10;
        hOffset += 10;
      }

      if (sharer.position === 'tl') {
        sharePosition = {
          top: top + vOffset,
          left: left + hOffset,
        };
      } else if (sharer.position === 'tr') {
        sharePosition = {
          top: top + vOffset,
          left: left + width - sharerWidth - hOffset
        };
      } else if (sharer.position === 'bl') {
        sharePosition = {
          top: top + height - sharerHeight - vOffset,
          left: left + hOffset
        };
      } else if (sharer.position === 'br') {
        sharePosition = {
          top: top + height - sharerHeight - vOffset,
          left: left + width - sharerWidth - hOffset
        };
      } else {
        // Center position
        sharePosition = {
          top: top + (height / 2) - (sharerHeight / 2) + vOffset,
          left: left + (width / 2) - (sharerWidth / 2) + hOffset
        };
      }

      sharePosition.top += topPositioner;
      sharePosition.left += leftPositioner;
      sharePosition.position = (sharer.currentImage.css('position') === 'fixed') ? 'fixed' : 'absolute';

      sharer.buttonEl.css(sharePosition);
    },

    getImageData: function(img) {
      var width = $(img).naturalWidth();
      var height = $(img).naturalHeight();
      var src = $(img).attr('src');
      var canvas = document.createElement('canvas');
      var maxWidth = 1280;
      var maxHeight = 800;

      if (src && src.toLowerCase().indexOf('.gif') > -1) {
        return null;
      }

      if (canvas) {
        // scale image down if too large
        var ratio = Math.min(maxWidth / width, maxHeight / height);
        if (ratio < 1.0) {
          width = width * ratio;
          height = height * ratio;
        }

        canvas.width = width;
        canvas.height = height;

        var ctx = canvas.getContext('2d');
        if (ctx) {
          ctx.drawImage(img.get(0), 0, 0, width, height);
          try {
            return canvas.toDataURL();
          } catch(e) {
          }
        }
      }

      return null;
    },

    charactersLeft: function(tweet) {
      return 280 - twitterText.txt.getTweetLength(tweet);
    },

    touch: function(e) {
      var width = Math.min(window.screen.availWidth || $(window).width(),  $(window).width());
      if ($.isCurrentUrlAllowed(sharer.display_rules, null, sharer.ctry, sharer.views)) {
        var t = $.timer('hideImageSharer');

        if (t) {
          t.kill();
        }

        var x = e.pageX || e.originalEvent.touches[0].pageX;
        var y = e.pageY || e.originalEvent.touches[0].pageY;
        var closestToPoint = $.nearest({x: x, y: y}, 'img');

        sharer.currentImage = null;

        if (!closestToPoint) {
          sharer.buttonEl.stop(true, true).fadeOut(500);
          return;
        }

        var naturalWidth = closestToPoint.naturalWidth();
        var naturalHeight = closestToPoint.naturalHeight();
        var width = closestToPoint.width();
        var height = closestToPoint.height();

        if (naturalWidth < 150 || naturalHeight < 150) {
          console.log('target is too small');
          sharer.buttonEl.stop(true, true).fadeOut(500);
          return;
        }

        // Force include if:
        // * Image has rel="share" attribute

        // Do not include if:
        // * Image is wrapped in an anchor tag with an href that is not a link to itself or a .jpg/.gif/.png
        // * Image is nested inside a form
        // * Image has rel="noshare" attribute
        // * Image is part of a content network like Outbrain
        // * Image is part of an ad network like Mode Media

        if (closestToPoint.parent().is('div[id^=grs_]')) {
          console.log('target is part of an ad network');
          sharer.buttonEl.stop(true, true).fadeOut(500);
          return;
        }

        if (closestToPoint.is('.ob-widget *')) {
          console.log('target is part of a content network');
          sharer.buttonEl.stop(true, true).fadeOut(500);
          return;
        }

        if (closestToPoint.is('.s.u.m.o.me *')) {
          console.log('target is part of a sumo tool');
          sharer.buttonEl.stop(true, true).fadeOut(500);
          return;
        }

        if (closestToPoint.attr('rel') && closestToPoint.attr('rel').toLowerCase().indexOf('noshare') === 0) {
          console.log('target has no share');
          sharer.buttonEl.stop(true, true).fadeOut(500);
          return;
        }

        if (closestToPoint.attr('rel') && closestToPoint.attr('rel').toLowerCase().indexOf('share') === 0) {
          console.log('target is force-shared');
        } else {
          var parent = closestToPoint.parent();
          var r = /[^/\\]+(?:jpg|gif|png)/gi;

          if (sharer.ignoreLinks) {
            if (parent && parent.get(0).tagName.toUpperCase() === 'A' && parent.attr('href') && parent.attr('href') !== closestToPoint.attr('src') && parent.attr('href').match(r) === null) {
              console.log('target links somewhere else');
              sharer.buttonEl.stop(true, true).fadeOut(500);
              return;
            }
          }

          if (sharer.ignoreImgLinks) {
            if (parent && parent.get(0).tagName.toUpperCase() === 'A' && parent.attr('href') && parent.attr('href') !== closestToPoint.attr('src') && parent.attr('href').match(r) !== null) {
              console.log('target images somewhere else');
              sharer.buttonEl.stop(true, true).fadeOut(500);
              return;
            }
          }

          if (closestToPoint.parents('form').length > 0) {
            console.log('target is inside a form');
            sharer.buttonEl.stop(true, true).fadeOut(500);
            return;
          }

          if (closestToPoint.is(':hidden') || closestToPoint.is(':invisible')) {
            console.log('target is invisible');
            sharer.buttonEl.stop(true, true).fadeOut(500);
            return;
          }

          if (sharer.relShareOnly) {
            console.log('target does not have rel="share"');
            sharer.buttonEl.stop(true, true).fadeOut(500);
            return;
          }

        }

        console.info('enter: ' + closestToPoint.nodeName);
        console.info('width: ' + closestToPoint.naturalWidth());

        sharer.currentImage = closestToPoint;

        sharer.positionSharer();

        if (!sharer.isOverFixedHeader()) {
          sharer.buttonEl.stop(true, true).fadeIn(500);

          $.timer('hideImageSharer', sharer.hideSharer, 5000).start();
        }
      }
    },

    mouseleave: function(e) {
      if (sharer.currentImage === null) {
        return;
      }

      var moveTo = $(e.toElement || e.relatedTarget);

      if (moveTo.hasClass('.sumome-image-sharer')) {
        return;
      }

      if (moveTo.closest('.sumome-image-sharer').length > 0) {
        return;
      }

      sharer.hideSharer();
    },

    hideSharer: function() {
      var t = $.timer('hideImageSharer');

      if (t) {
        t.kill();
      }

      sharer.currentImage = null;
      sharer.buttonEl.stop(true, true).fadeOut(500);
    },

    scroll: function() {
      if (sharer.isOverFixedHeader()) {
        sharer.hideSharer();
      }
    },

    isOverFixedHeader: function() {
      if (!sharer.buttonEl) {
        return false;
      }

      var isShowinSharer = (sharer.buttonEl.css('opacity') === '1');
      var hasFixedHeader = ($('header').css('position') === 'fixed');

      if (isShowinSharer && hasFixedHeader) {
        var shadowOffSet = 8;
        var sharerElCoord = {
          x: parseInt(sharer.buttonEl.css('left').replace('px','')) - $(window).scrollLeft() - shadowOffSet,
          y: parseInt(sharer.buttonEl.css('top').replace('px','')) - $(window).scrollTop() - shadowOffSet,
          width: sharer.buttonEl.width() + 2*shadowOffSet,
          height: sharer.buttonEl.height() + 2*shadowOffSet
        }
        var headerElCoord = {
          x: $('header').position().left,
          y: $('header').position().top,
          width: $('header').width(),
          height: $('header').height()
        }

        if (doSquaresIntersect(sharerElCoord, headerElCoord)) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    },

    checkAndAddUTMParams: function(url, service) {
      if (sharer.hasImageSharer && url && 'utm' in sharer && sharer.utm) {
        var uri = URI(url);
        if ('utm_source' in sharer && sharer.utm_source) {
          uri.removeQuery('utm_source');
          uri.addQuery('utm_source', sharer.utm_source.replace('{service}', service));
        }

        if ('utm_medium' in sharer && sharer.utm_medium) {
          uri.removeQuery('utm_medium');
          uri.addQuery('utm_medium', sharer.utm_medium.replace('{service}', service));
        }

        if ('utm_name' in sharer && sharer.utm_name) {
          uri.removeQuery('utm_campaign');
          uri.addQuery('utm_campaign', sharer.utm_name.replace('{service}', service));
        }

        if ('utm_custom_key' in sharer && sharer.utm_custom_key) {
          if ('utm_custom_val' in sharer && sharer.utm_custom_val) {
            uri.removeQuery(sharer.utm_custom_key);
            uri.addQuery(sharer.utm_custom_key, sharer.utm_custom_val.replace('{service}', service));
          }
        }

        url = uri.toString();
      }
      return url;
    }
  };

  return sharer;
});
